<template>
  <v-card>
    <Cabecera 
      v-if="!incrustado && !simplificada" 
      tipoModuloActual="kyc"
      :incrustado="incrustado"/>
    <StepperPortal v-if="!incrustado && !simplificada" tipoModuloActual="kyc" />
    <v-container fluid>
      <o-big-title v-if="incrustado">{{titulo}}</o-big-title>
      <o-base-justify-text>
        <v-layout column>
          <span v-if="reserva.cod_tipo_operacion == 'VTA'" v-html="getTexto('kyc.bienvenida', reserva.codigoPromocion)"/>
          <span v-else v-html="getTexto('kyc.bienvenidaAlquiler', reserva.codigoPromocion)"/>
        </v-layout>
      </o-base-justify-text>
      <o-base-justify-text v-if="incrustado">
        {{$t('reservas.kyc.textoIncrustado')}}
      </o-base-justify-text>
      <o-base-justify-text>
        <span v-html="getTexto('kyc.subtitulo', reserva.codigoPromocion)"/>
      </o-base-justify-text>
      <!-- Resultado de validación -->
      <v-layout v-if="!kycVer && getTitular && getTitular.validacionKyc" column>
        <o-medium-title>{{$t('reservas.kyc.validacion')}}</o-medium-title>
        <o-base-justify-text>
          {{$t('reservas.kyc.formularioRechazado')}}
        </o-base-justify-text>
        <o-base-justify-text colorClass="error--text">
          {{$t('reservas.kyc.comentarioRevisor')}}
        </o-base-justify-text>
        <o-base-justify-text style="white-space: pre-line" colorClass="error--text">{{
          getTitular.validacionKyc.textoValidacion
        }}</o-base-justify-text>
      </v-layout>
      <v-form ref="form" v-model="valid">
        <BaseKyc
          :compradores.sync="compradores"
          :expansion.sync="expansion"
          :incrustado="incrustado"
          :cargandoExterior="cargandoExterior"
          :waitingForLoad="waitingForLoad"
          :guardarYEnviar="guardarYEnviar"
          :mostrarDescripcion="true"
          :tipo="'kyc'"
        />
      </v-form>
      <!-- Ver contrato -->
      <v-layout v-if="kycVer && reserva.contratoKyc !== null && !simplificada" column>
        <o-medium-title>{{$t('reservas.documentacion.contratoKyc')}}</o-medium-title>
        <v-layout justify-center>
          <v-btn
            large
            color="primary"
            @click.stop
            :href="reserva.contratoKyc && reserva.contratoKyc.documentoFirmado ? $contrato(reserva.contratoKyc.documentoFirmado.documento.id) : ''"
            target="_blank"
          >
            {{$t('reservas.kyc.verContrato')}}
          </v-btn>
        </v-layout>
      </v-layout>
      <!-- Botonera -->
      <v-layout justify-space-between align-center>
        <v-flex xs2>
          <v-btn
            flat
            class="titleColor--text ml-0 pl-0"
            :disabled="waitingForLoad  || cargandoExterior"
            @click="$router.push({
              name: 'reservas.id',
              params: {id: reserva.id}
            })"
            v-if="!incrustado && !simplificada"
            :icon="$vuetify.breakpoint.xsOnly"
          >
            <!-- eslint-disable-next-line -->
            <v-icon class="mr-1">{{$vuetify.breakpoint.xsOnly ? 'arrow_back':'chevron_left'}}</v-icon>
            <span class="hidden-xs-only">{{$t('general.misc.volver')}}</span>
          </v-btn>
        </v-flex>
        <v-layout 
          v-if="!kycVer"
          :column="$vuetify.breakpoint.smAndDown" 
          :shrink="$vuetify.breakpoint.smAndDown" 
          justify-space-around
        >
          <v-btn
            v-if="!incrustado && !simplificada" 
            large
            color="primary"
            :disabled="waitingForLoad || cargandoExterior"
            :loading="waitingForLoad || cargandoExterior"
            @click="aceptar(false)"
          >
            {{$t('reservas.kyc.continuarMasTarde')}}
          </v-btn>
          <v-btn
            large
            color="primary"
            :disabled="waitingForLoad || cargandoExterior"
            :loading="waitingForLoad || cargandoExterior"
            @click="aceptar(true)"
          >
            {{simplificada ? $t('general.misc.guardar') :incrustado ? $t('reservas.kyc.continuar') : $t('reservas.kyc.aceptar')}}
          </v-btn>
        </v-layout>
        <v-flex xs2/>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseKyc from '@/components/reservas/comprador/BaseKyc'
import MixinComprador from '@/mixins/comprador'
import MixinEstadoKyc from '@/mixins/estadosReserva/estadoKyc'
import rules from '@/mixins/rules'
import Cabecera from '@/components/Cabecera'
import StepperPortal from '@/components/StepperPortal'

export default {
  mixins: [rules, MixinComprador, MixinEstadoKyc],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    actual: {
      type: Boolean,
      default: true
    },
    simplificada: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      compradoresCreated: false,
      waitingForLoad: false,
      compradores: [],
      expansion: [],
      valid: false,
      guardarYEnviar: false
    }
  },
  components: {
    BaseKyc, Cabecera, StepperPortal
  },
  async created () {
    this.inicializarCompradores()
    this.$nextTick(() => {
      this.compradoresCreated = true
    })
  },
  computed: {
    ...mapGetters({
      modulos: 'modulosOrdenes/modulos/getAll',
      getGenerarContratoKyc: 'modulosOrdenes/getGenerarContratoKyc',
      reserva: 'reservas/_id/getActual'
    }),
    titulo () {
      return this.getTexto('modulos.kyc' + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      modificarCompradores: 'compradores/modificar'
    }),
    terminar (terminar = true) {
      this.$emit('cambiado', false)
      this.$emit('terminado', terminar)
    },
    async aceptar (completado) {
      this.guardarYEnviar = completado
      await this.$nextTick()
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      if (completado) {
        if (this.compradores.some(x => x.juridico && x.kycJuridico.titulares.length === 0) && this.getGenerarContratoKyc) {
          this.addAlert({texto: this.$t('reservas.kyc.avisoTitular'), color: 'error'})
          return
        }
        if (this.compradores.some(x => x.juridico && x.kycJuridico.apoderados.length === 0) && this.getGenerarContratoKyc) {
          this.addAlert({texto: this.$t('reservas.kyc.avisoApoderado'), color: 'error'})
          return
        }
        if (this.compradores.some(x => x.juridico && !x.kycJuridico.cotizada && x.kycJuridico.titularesNoCotizada.length === 0) && this.getGenerarContratoKyc) {
          this.addAlert({texto: this.$t('reservas.kyc.avisoMercado'), color: 'error'})
          return
        }
        let suma = 0
        for (let i = 0; i < this.compradores.length; i++) {
          suma += Number(this.compradores[i].porcentajeParticipacion)
        }
        if (suma < 99.9 || suma > 100.1) {
          this.addAlert({texto: this.$t('reservas.kyc.avisoPorcentaje'), color: 'error'})
          return
        }
      }
      try {
        this.waitingForLoad = true
        await this.modificarCompradores({
          id: this.reserva.id,
          compradores: this.compradores,
          completado: completado,
          simplificada: this.simplificada
        })
        this.terminar(completado)
        if (!this.incrustado) {
          this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
        }
        this.waitingForLoad = false
        this.guardarYEnviar = true
        return true
      } catch (error) {
        this.waitingForLoad = false
        this.guardarYEnviar = true
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  },
  watch: {
    compradores: {
      deep: true,
      handler () {
        this.$emit('cambiado', this.compradoresCreated)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/kyc/Kyc.vue